import React, { useState } from "react";
import { Button } from "@material-ui/core";
import { parseJSONfromText } from "../../author/hooks/useImportPlans"; // Adjust the import path as necessary
import Dialog from "../../../common/Dialog";
import Loading from "../../Loading";
import Checkbox from "../../../common/Checkbox";
import TextInputForVision from "../../plan/components/TextInputForVision";
import { useFormikContext } from "formik";
import { Action } from "../../../../types/ActionType";

const ImportActions = ({
  habitId,
  setActions,
  prevActions,
}: {
  habitId: string;
  setActions;
  prevActions;
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [show, setShow] = useState(false);
  const [data, setData] = useState<Action[] | null>(null);
  const [isJSONImport, setIsJSONImport] = useState(false);

  const parseDataToActions = (rawData: any): Action[] => {
    if (!rawData) {
      console.log("No Data to parse");
      return [];
    }

    return rawData.map((item: any) => {
      const action: Action = {
        id: item.id || "",
        name: item.name || "",
        description: item.description || "",
        habitId: habitId,
        actionType: item.actionType || "",
        createdAt: new Date().toISOString(),
      };

      if (item.duration != null) action.duration = Number(item.duration);
      if (item.goal) action.goal = item.goal;
      if (Array.isArray(item.subactions)) action.subactions = item.subactions;
      if (item.backgroundImageURL)
        action.backgroundImageURL = item.backgroundImageURL;
      if (Array.isArray(item.tags)) action.tags = item.tags;
      if (item.updatedAt) action.updatedAt = item.updatedAt;

      return action;
    });
  };

  const updateFormikActions = () => {
    if (!data) return;

    const parsedActions = parseDataToActions(data);
    const updatedActions = [...prevActions, ...parsedActions];
    setActions(updatedActions);
    setShow(false);
  };

  const toggleJSONImport = () => {
    setIsJSONImport(!isJSONImport);
  };

  const handleTextToUpload = async (text: string) => {
    setIsLoading(true);
    console.log("TextToBeUploaded", text);
    let actionsFormat;

    actionsFormat = parseJSONfromText(text);

    setData(actionsFormat);
    setIsLoading(false);
    console.log("ActionsFormat", actionsFormat);
  };
  function generateActionPrompt(extractedText: string) {
    return `
      Please format the following information into a JSON array of actions.
      
      Ensure to extract and include all relevant details, even if they are spread across multiple pages.
      
      The JSON structure should be as follows:
      
      [
        {
          id: string,
          name: string,
          description: string,
          duration?: number,
          goal?: string,
          actionType: string, //exercise, diet, other..
          subactions?: [
            {
              id: string,
              name: string,
              description: string,
              duration?: number,
              repetitions?: number,
              sets?: number,
              caloriesBurned?: number,
              intensityLevel?: string,
              equipmentNeeded?: string[],
              location?: string,
              restTime?: number,
              backgroundImageURL?: string,
              videoURL?: string,
              quantity?: string,
              notes?: string,
              instructionsURL?: string,
              actionType: string,
              createdAt: string,
              updatedAt?: string,
              isCustom?: any
              ingredients?: [{"measurementSize": "string", "name": "string", "quantity": "number"}]
            }
          ],
          backgroundImageURL?: string,
          tags?: any[],
          createdAt: string,
          updatedAt?: string
        }
      ]
      
      Here is the extracted text:
      
      ${extractedText}
      
      Please format the extracted text into the corresponding JSON structure, ensuring that all relevant details are included and nothing is omitted:
    `;
  }
  return (
    <div>
      <Button
        style={{ marginTop: 8 }}
        color="primary"
        variant="outlined"
        onClick={() => setShow(true)}
      >
        Import Actions
      </Button>
      <Dialog
        positiveAction={updateFormikActions}
        negativeAction={() => setShow(false)}
        onCloseDialog={() => setShow(false)}
        positiveText="Finish"
        negativeText="Cancel"
        description=""
        title="Import Actions"
        isOpen={show}
        ExtraButton={
          !isLoading ? (
            <div>
              <Checkbox
                checked={isJSONImport}
                onChange={toggleJSONImport}
                label="Import as JSON"
              />
              <TextInputForVision
                placeholder={`Please format the following information into a JSON array of actions.
      
      Ensure to extract and include all relevant details, even if they are spread across multiple pages.
      
      The JSON structure should be as follows:
      
      [
        {
          id: string,
          name: string,
          description: string,
          duration?: number,
          goal?: string,
          actionType: string, //exercise, diet, other..
          subactions?: [
            {
              id: string,
              name: string,
              description: string,
              duration?: number,
              repetitions?: number,
              sets?: number,
              caloriesBurned?: number,
              intensityLevel?: string,
              equipmentNeeded?: string[],
              location?: string,
              restTime?: number,
              backgroundImageURL?: string,
              videoURL?: string,
              quantity?: string,
              notes?: string,
              instructionsURL?: string,
              actionType: string,
              createdAt: string,
              updatedAt?: string,
              isCustom?: any
            }
          ],
          backgroundImageURL?: string,
          tags?: any[],
          createdAt: string,
          updatedAt?: string
        }
      ]
      
      Here is the extracted text:
      
      TEXT
      
      Please format the extracted text into the corresponding JSON structure, ensuring that all relevant details are included and nothing is omitted:
  `}
                onTextExtracted={handleTextToUpload}
              />
            </div>
          ) : (
            <Loading />
          )
        }
      />
    </div>
  );
};

export default ImportActions;
